<template>
    <div style="margin: 10px" class="balance-inventory-records">
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item>
                <el-select v-model="formInline.cardType" placeholder="请选择卡类型" style="width:220px">
                    <el-option label="礼品卡" :value="1"></el-option>
                    <el-option label="优惠券" :value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="formInline.cardState" placeholder="请选择卡状态" style="width:220px">
                    <el-option label="在库" :value="1"></el-option>
                    <el-option label="出库" :value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-input
                    v-model="formInline.batchNo"
                    placeholder="请输入卡批次">
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-input v-model="formInline.startNo"
                          placeholder="请输入开始卡号">
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-input
                    v-model="formInline.endNo"
                    placeholder="请输入结束卡号">
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="success" @click="searchData">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="giftCardBatchList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <el-table-column type="index" label="序号" width="50" fixed="left"></el-table-column>
            <el-table-column prop="batchName" label="批次名称" fixed="left"></el-table-column>
            <el-table-column prop="cardId" label="卡Id" width="160"></el-table-column>
            <el-table-column prop="cardTypeName" label="卡类型"></el-table-column>
            <el-table-column  width="100" label="状态">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.cardState==1?'danger':'primary'">{{scope.row.cardStateName}}</el-tag>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="formInline.currentPage"
                :page-sizes="GCONFIG.pageSizes"
                :page-size="formInline.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="formInline.recordsTotal">
            </el-pagination>
        </div>
    </div>
</template>
<script>
//导入 HTTP请求方法
import {balanceInventoryRecords,getUserListForDropbox,getBalanceCardDetail,balanceCardOut,balanceCardModuleUpload,balanceCardModuleDownload} from '@/api/api';
import CardBalanceOut from '@/components/card/CardOutList.vue'
export default {
    data() {
        return {
            giftCardBatchList: [],// 批次信息
            userList: [],
            loading: true,
            formInline: {
                platformId: 1,
                currentPage: 1,
                pageSize: 10,
                recordsTotal: 0
            },
            outFormParam: {},
            cardFormParam: {},
            currentBatchNo:'',
            outListVisible: false,
            newOutVisible: false,

        }
    },
    components: {CardBalanceOut},
    //挂载时候执行
    mounted(){
        //初始化首页数据
        this.queryGiftCardBatch();
    },

    methods: {
        queryGiftCardBatch() {
            this.loading = true;
            let param = this.formInline;
            console.log(22,param)
            balanceInventoryRecords(this.formInline).then((res) => {
                this.loading = false;
                if (res.data.status == 200) {
                    this.formInline.recordsTotal = res.data.value.total;
                    this.giftCardBatchList = res.data.value.list;
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message||res.data.message||'网络异常',
                        type: 'error'
                    });
                }
            }).catch((err) => {
                console.log(err)
                this.$message({
                    showClose: true,
                    message: err.message||err.data.message||'网络异常',
                    type: 'error'
                });
            });
        },
        searchData(){
            this.formInline.currentPage = 1
            this.queryGiftCardBatch()
        },
        handleSizeChange(val) {
            this.formInline.pageSize = val;
            this.queryGiftCardBatch();
        },
        handleCurrentChange(val) {
            this.formInline.currentPage = val;
            this.queryGiftCardBatch();
        }

    }
}
</script>
<style lang="scss">
.balance-card-batch{
    .el-input-number .el-input__inner{
        text-align: left;
    }
    .el-drawer__header{
        margin-bottom: 15px;
    }
}

</style>


// WEBPACK FOOTER //
// src/views/giftCard/BalanceInventoryRecords.vue